/** Returns true if the browser is Google Chrome (or derivatives). */
function isChrome() {
  const userAgent = navigator.userAgent;
  return /Chrome/.test(userAgent);
}

/** Caches the result of a test function. */
function cached(testFunc: () => boolean) {
  let cache: boolean | null = null;
  return () => {
    if (cache === null) {
      cache = testFunc();
    }
    return cache;
  };
}

/** Returns true if the browser supports multi-channel audio playback. */
export const isMultiChannelAudioSupported = cached(() => {
  return isChrome();
});
